import { atom } from "recoil";

export const setDoctorExperience = atom({
    key: 'setDoctorExperience',
    default: [], // Initialize as an empty array
});
